<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">キャラクター一覧</h2>
        <permission-guard situation="character_image_management">
          <v-btn color="primary" dark outlined @click="newCharacter">
            <v-icon left> mdi-plus </v-icon>
            新規追加
          </v-btn>
          <v-row class="mt-5">
            <v-col v-for="c in characters" :key="c.id" cols="4">
              <v-card>
                <v-card-text class="ma-2">
                  <v-row>
                    <v-col cols="5" class="text-center">
                      <v-avatar size="80">
                        <img :src="c.avatar.thumb.url" />
                      </v-avatar>
                    </v-col>
                    <v-col cols="7">
                      <span class="subtitle-1">
                        {{ c.name }}
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <v-spacer />
                  <v-btn text color="primary" small @click="editCharacter(c)">
                    編集
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </permission-guard>
      </v-col>
    </v-row>
    <CharacterForm
      :dialog="dialog"
      :character="character"
      @update-character="updateCharacter"
      @create-character="createCharacter"
    ></CharacterForm>
  </v-container>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import headUtilsMixin from '@/mixins/head_utils'
import CharacterForm from '@/pages/admin/characters/form.vue'

export default {
  components: {
    PermissionGuard,
    CharacterForm
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'キャラクター一覧',
      dialog: false,
      characters: [],
      character: {
        id: null,
        name: null,
        avatar: null
      }
    }
  },
  mounted: function () {
    axios.get('/api/character_images').then(
      ({ data }) => {
        data.data.forEach(({ attributes }) => this.characters.push(attributes))
      },
      (error) => {
        console.error(error)
      }
    )
  },
  methods: {
    newCharacter () {
      this.character = {
        id: null,
        name: null,
        avatar: null
      }
      this.dialog = true
    },
    editCharacter (character) {
      this.character = { ...character }
      this.dialog = true
    },
    createCharacter () {
      this.$store.dispatch('LoaderStore/displayLoader')
      const payload = this.character
      let formData = new FormData()
      formData.append('character_image[name]', payload.name || '')
      formData.append('character_image[avatar]', payload.avatar)
      axios
        .post('/api/character_images', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            const character = data.data.attributes
            this.characters.unshift(character)
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: 200,
              message: 'キャラクターを作成しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.dialog = false
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    updateCharacter () {
      this.$store.dispatch('LoaderStore/displayLoader')
      const payload = this.character
      let formData = new FormData()
      formData.append('character_image[name]', payload.name)
      formData.append('character_image[avatar]', payload.avatar)
      axios
        .patch(`/api/character_images/${payload.id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            const character = data.data.attributes
            Object.assign(
              this.characters.find((c) => c.id === character.id),
              character
            )

            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: 200,
              message: '更新しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.dialog = false
          },
          (error) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }
}
</script>

<style scoped></style>
